module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    }
  }, [_c('el-col', {
    staticClass: "search-box",
    attrs: {
      "span": 24
    }
  }, [_c('span', [_c('label', [_vm._v("编号：")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入编号"
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  })], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("序列号：")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入序列号"
    },
    model: {
      value: (_vm.deviceSn),
      callback: function($$v) {
        _vm.deviceSn = $$v
      },
      expression: "deviceSn"
    }
  })], 1), _vm._v(" "), _c('span', [_c('label', [_vm._v("设备类型:")]), _vm._v(" "), _c('DropdownSelect', {
    attrs: {
      "action": _vm.api.shop.device.listtype,
      "textField": "name",
      "valueField": "id"
    },
    model: {
      value: (_vm.deviceTypeId),
      callback: function($$v) {
        _vm.deviceTypeId = $$v
      },
      expression: "deviceTypeId"
    }
  })], 1), _vm._v(" "), _c('span', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)])], 1), _vm._v(" "), _c('page-table', {
    attrs: {
      "data-api": this.api.shop.device,
      "viewable": false,
      "keyField": "id",
      "deletable": false,
      "editable": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('el-table-column', {
    attrs: {
      "prop": "deviceSn",
      "label": "序列号"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceTypeName",
      "label": "设备类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceCategoryName",
      "label": "设备名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二维码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleQrcode(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "添加时间",
      "formatter": _vm.dateFormatter
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看二维码",
      "visible": _vm.qrcode.dialogVisible,
      "width": _vm.isMobile() ? '80%' : '50%'
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.qrcode, "dialogVisible", $event)
      }
    }
  }, [_c('p', [_c('span', [_vm._v("下载二维码请\"右击\"图片选择\"另存为\"")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.qrcode.imageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.qrcode.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85395bd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/device/List.vue
// module id = 1181
// module chunks = 2